/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import { fetchPhpEigth } from "api";
import imgBreadCrum from "assets/img/mex/accidentesPersonales/imgbreadcrumAP.png";
import ResumenAPIndividual from "components/APIndividual/ResumenAPIndividual";
import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import Page from "components/Page";
import { ALBERT_EVENTS } from "constants/albert_events";
import {
  ambienteAplicacion,
  urlActualizarCotitzacionAP,
  urlEmisionPoliza,
  urlResumenCotizadorMex,
  urlTarifacionCotizadorMex,
} from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import useAlbert from "hooks/useAlbert";
import withValidarRecuperar from "HOC/withValidarRecuperar";
import useCustomRouter from "hooks/useCustomRouter";
import useLoading from "hooks/useLoading";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import useParametrosPago from "redux/hooks/useParametrosPago";
import { PASOS_BREADCRUMBS, PRODUCTOS } from "utils/constants";
import { getColorByIndex } from "utils/funciones";
import Loading from "wrappers/Loading";
import "./styles.scss";
import { getSeleccionado } from "./utils";

const APIndividualResumenContainer = ({
  params: { idCotizacion },
  addWarningToast,
  dataUsuario,
}) => {
  const { setProductoActivo } = useNavbarContext();
  const [loading, setLoading] = useState(false);
  const { cliCodigoCore } = dataUsuario;
  const [datosTarifacion, setDatosTarifacion] = useState(null);

  const history = useCustomRouter();

  const { loading: recalculando, setLoading: recalcular } = useLoading();
  const [permiteEmitir, setPermiteEmitir] = useState(true);
  const [cotizacion, setCotizacion] = useState(null);

  const [prod, setProducto] = useState(null);

  const [plan, setPlan] = useState(null);

  const methods = useForm();

  const { handleContinue, fetchParametros, ...stateParametrosPago } = useParametrosPago();
  const { addApEvent } = useAlbert();
  useEffect(() => {
    if (stateParametrosPago.error) {
      addWarningToast(stateParametrosPago.error.message, { autoDismiss: false });
    }
  }, [stateParametrosPago.error]);

  const getResumen = async () => {
    setProductoActivo(PRODUCTOS.APINDIVIDUAL);
    setLoading(true);

    const DataResumen = {
      cotDatos: { ambiente: ambienteAplicacion, cotCodigo: idCotizacion },
    };

    const resResumen = await fetchPhpEigth(urlResumenCotizadorMex, DataResumen);

    if (resResumen.transaccion) {
      const totales = resResumen.cotConsulta.totGenerales[0];
      setDatosTarifacion(totales);
      setCotizacion(resResumen.cotConsulta);
      const productoSeleccionado = getSeleccionado(resResumen.cotConsulta.prodDatos);

      setProducto(productoSeleccionado);

      const planSeleccionado = getSeleccionado(productoSeleccionado.planes);

      const index = productoSeleccionado.planes.indexOf(planSeleccionado);
      planSeleccionado.bgColor = getColorByIndex(index);
      setPlan(planSeleccionado);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchParametros();
    getResumen();
  }, []);

  useEffect(() => {
    if (datosTarifacion) {
      if (!datosTarifacion?.permitirEmitir) {
        addWarningToast(datosTarifacion.msgError);
      }
      setPermiteEmitir(datosTarifacion?.permitirEmitir);
    }
  }, [datosTarifacion]);

  const tarifar = async ({ idPlazo, formaPago, labelPlazo }) => {
    recalcular(true);
    const DataTarifacion = {
      ambiente: ambienteAplicacion,
      cotCodigo: idCotizacion,
      idPlazo,
      formaPago,
      labelPlazo,
    };

    const res = await fetchPhpEigth(urlTarifacionCotizadorMex, DataTarifacion);

    if (res.transaccion) {
      setDatosTarifacion(res.datosTarifacion);

      setCotizacion({
        ...cotizacion,
        carUrlPdf: res.datosTarifacion.urlPdfCotizacion,
      });
      delete res.datosTarifacion.urlPdfCotizacion;

      let DataGuardarTotales = {
        ambiente: ambienteAplicacion,
        prodCodigo: "APINDIVIDUAL",
        pasoCodigo: "guardarTotales",
        items: {
          idCotizacion: idCotizacion,
          usuCotiza: cliCodigoCore || "",
          datosTarifacion: res.datosTarifacion,
        },
      };

      recalcular(false);

      const resGuardar = await fetchPhpEigth(urlActualizarCotitzacionAP, DataGuardarTotales);

      if (!resGuardar || !resGuardar.transaccion) {
        addWarningToast("Ha ocurrido un problema al guardar los totales");
      }
    } else {
      return addWarningToast("Ha ocurrido un problema al realizar la tarifación");
    }
  };

  const onContinuar = async () => {
    const Data = {
      datosCotizador: {
        ambiente: ambienteAplicacion,
        prodCodigo: "APINDIVIDUAL",
        cotPasoCodigo: "crearPoliza",
        cotCodigo: idCotizacion,
      },
    };

    setLoading(true);
    const res = await fetchPhpEigth(urlEmisionPoliza, Data);

    if (res.transaccion && res.catalogo.idPoliza) {
      const route = res?.catalogo?.pasosRedireccionamiento.find((e) => e.codigo === "resumen");
      addApEvent(ALBERT_EVENTS.PAYMENT_INFO);

      history.replace(route.goTo+`&ramo=APINDIVIDUAL&idCot=${idCotizacion}`);
      history.push(route.goTo+`&ramo=APINDIVIDUAL&idCot=${idCotizacion}`);
    }

    setLoading(false);
  };

  const onClickAtras = () => {
    history.push(`/accidentes-planes-personas/${idCotizacion}?recuperar=true`);
  };

  return (
    <Loading loading={loading}>
      {cotizacion && datosTarifacion && prod && plan && (
        <FormProvider {...methods}>
          <div className='cr-content'>
            <Page>
              <BreadCurmb
                title='Cotización Accidentes Personales'
                subtitle='Cotización Accidentes Personales'
              />

              <BreadCrumbPasosV2
                {...PASOS_BREADCRUMBS[PRODUCTOS.APINDIVIDUAL].breadCrumbPasosCotizacion[3]}
                pasos={PASOS_BREADCRUMBS[PRODUCTOS.APINDIVIDUAL]?.pasosCotizacion}
              />

              <ResumenAPIndividual
                cotizacion={cotizacion}
                prod={prod}
                plan={plan}
                datosTarifacion={datosTarifacion}
                idCotizacion={idCotizacion}
                imgBreadCrum={imgBreadCrum}
                dataUsuario={dataUsuario}
                setDatosTarifacion={setDatosTarifacion}
                recalculando={recalculando}
                recalcular={recalcular}
                tarifar={tarifar}
              />

              <div className='row justify-content-center my-5'>
                <div className='col-11 col-sm-5 col-md-3 col-xl-2'>
                  <button className='btn btn-atras-api' onClick={onClickAtras}>
                    Atrás
                  </button>
                </div>
                <div className='col-11 col-sm-5  col-md-3 col-xl-2'>
                  <button
                    className='btn btn-siguiente-api'
                    onClick={handleContinue(methods.handleSubmit(onContinuar))}
                    type='submit'
                    disabled={recalculando || !permiteEmitir}>
                    Siguiente
                  </button>
                </div>
              </div>
            </Page>
          </div>
        </FormProvider>
      )}
    </Loading>
  );
};

export default withValidarRecuperar(APIndividualResumenContainer);
